import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Button, message, Spin } from 'antd';
import Sdk from 'casdoor-js-sdk'; // Only needed for signin_redirect

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const casdoorConfig = {
    serverUrl: process.env.REACT_APP_CASDOOR_SERVER_URL || '',
    clientId: process.env.REACT_APP_CASDOOR_CLIENT_ID || '',
    organizationName: process.env.REACT_APP_CASDOOR_ORGANIZATION_NAME || '',
    appName: process.env.REACT_APP_CASDOOR_APP_NAME || '',
    redirectPath: '/callback',
  };

  useEffect(() => {
    // Check if already logged in by verifying session with backend
    // Backend will check httpOnly cookie and verify with Casdoor
    const checkSession = async () => {
      const apiUrl = process.env.REACT_APP_AZINSIGHT_API;
      if (!apiUrl) {
        return;
      }

      try {
        const response = await fetch(`${apiUrl}/api/v1/admin/auth/verify-session`, {
          method: 'GET',
          credentials: 'include', // Important: include cookies
        });

        if (response.ok) {
          // Session is valid, redirect to user management
          navigate('/user-management', { replace: true });
        }
      } catch (error) {
        // Session invalid or error, stay on login page
        console.error('Session check error:', error);
      }
    };

    checkSession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  const handleLogin = async () => {
    if (!casdoorConfig.serverUrl || !casdoorConfig.clientId) {
      message.error('Admin Dashboard not configured. Please check environment variables.');
      return;
    }

    setLoading(true);
    try {
      const sdk = new Sdk(casdoorConfig);

      // Use signin_redirect() to properly handle PKCE and state
      // This ensures state is correctly stored in sessionStorage
      await sdk.signin_redirect();
      // Note: After redirect, we won't return here, so loading state doesn't matter
    } catch (error: any) {
      console.error('Login error:', error);
      message.error(error.message || 'Failed to initiate login');
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: '#f0f2f5'
    }}>
      <Card
        title="Admin Portal Login"
        style={{ width: 400 }}
      >
        {loading ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <Spin size="large" />
            <p style={{ marginTop: '16px' }}>Redirecting to login...</p>
          </div>
        ) : (
          <div>
            <Button
              type="primary"
              size="large"
              block
              onClick={handleLogin}
              loading={loading}
            >
              Login with Admin Dashboard
            </Button>
          </div>
        )}
      </Card>
    </div>
  );
};

export default Login;
